import Dropzone from "dropzone";

let dropzoneRowTemplate;
let dropzoneConfig;
let processedAttachments = [];

let allowedFormats = {
    all: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.oasis.opendocument.text,image/png,image/jpeg,image/gif,image/jpg',
    img: 'image/png,image/jpeg,image/gif,image/jpg',
    doc: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.oasis.opendocument.text',
}



const getConfig = (options) => {
    let dz
    const maxFileSize = 10
    dropzoneRowTemplate = document.querySelector('#dropzone-file').innerHTML;
    const acceptedFiles = allowedFormats.all/*options?.accessFileType && allowedFormats?.[options?.accessFileType]
                        ? allowedFormats[options.accessFileType]
                        : allowedFormats.all*/
    delete options?.accessFileType
    dropzoneConfig = {
        autoProcessQueue: false,
        thumbnailHeight: 80,
        previewTemplate: dropzoneRowTemplate,
        maxFilesize: maxFileSize,
        url: 'test',
        acceptedFiles: acceptedFiles,
        init: function () {
            dz = this
            this.on("addedfile", function (file) {
                const errMessage = document.querySelector('.dropzone-error-message-container')
                errMessage.classList.add('d-none')

                let newName = file.upload.filename.length > 15
                            ? file.upload.filename.substring(0, 12) + '...'
                            : file.upload.filename

                file.previewElement.querySelector('[data-dz-name]').textContent = newName
                const linkEl = file.previewElement.querySelector('.dz-file-link')
                linkEl.href = URL.createObjectURL(file)
                linkEl.download = file.upload.filename
                if (this.getUploadingFiles().length === 0) {
                    document.dispatchEvent(new CustomEvent('added_file', { detail: { file } }))
                }
                $('#submit-attachments').removeAttr('disabled');
            });

            this.on('error', function(file){
                const allowTypes = acceptedFiles.split(',').map(el=>el.trim())
                const imageTypes = allowedFormats.img.split(',').map(el=>el.trim())
                if(allowTypes.includes(file.type) && imageTypes.includes(file.type))
                    return
                const errMessage = document.querySelector('.dropzone-error-message-container')
                file.previewElement.remove()
                dz.files = dz.files.filter(f=> f!=file)
                errMessage.textContent = "The file has exceeded the allowed size or is of a prohibited type"
                errMessage.classList.remove('d-none')
                return
            })
        },
        renameFile: function (file){
            const names = dz.files.map(f=>f.name)
            const index = names.filter(n=>n==file.name).length
            let name = file.name
            if(index != 0){
                name = file.name.split('.')
                name[name.length-2] = name[name.length-2]+'_'+index
                name = name.join('.')
            }
            return name
        }
    };

    setConfig(options);
}

const setConfig = (options, configObject=dropzoneConfig) => {
    for (const [param, value] of Object.entries(options)) {
        configObject[param] = value;
    }
}

export const DropZoneWrapper = (() => {

    let dropzone;

    return class DropZoneWrapper {

        constructor(options={}) {

            processedAttachments = []

            if (options.modal) {
                if (options.modal.template) {
                    const formContainer = document.querySelector('#form-container');
                    const dropzoneTemplate = document.querySelector(options.modal.template);
                    const element = dropzoneTemplate.content.cloneNode(true);

                    const alredyContainedDropzone = formContainer.querySelector(options.modal.selector);
                    if (alredyContainedDropzone) formContainer.removeChild(alredyContainedDropzone);

                    formContainer.appendChild(element);
                }

                this.container = $(options.modal.selector);

                this.show();

                this.dropzoneContainer = this.container.find('[data-dropzone]');

                dropzone = new Dropzone(this.dropzoneContainer[0], dropzoneConfig);

                this.listners(options);
            }
        }

        show() {
            this.container.modal('show');
        }

        listners(options) {
            this.submit = this.container.find(options.modal.submit.element);
            this.submit.on(options.modal.submit.event, () => {
                options.modal.submit.handler(dropzone.files, options.successCallback);
            });

            $(dropzone.element).on('attachment-owner-created', (e) => {
                options.modal.submit.handler(dropzone.files);
            });

            this.remove_file = this.container.find(options.modal.remove_file.element);
            this.container.on(options.modal.remove_file.event, options.modal.remove_file.element,(e)=>{
                let parent =  $(e.target).parents('.dz-preview');
                dropzone.files.forEach(file => {
                    if ($(file.previewTemplate)[0] == parent[0])
                        dropzone.removeFile(file)
                })
                if (dropzone.files.length == 0) {
                    $(options.modal.submit.element).attr('disabled', 'disabled');
                }
            });

        }

        dispatchOwnerCreated() {
            dropzone.element.dispatchEvent(new CustomEvent('attachment-owner-created'));
        }

        updateConfig(options) {
            setConfig(options, dropzone.options);
        }

        static init(options, dropzoneConfig={}) {

            getConfig(dropzoneConfig);
            const dropzone = new DropZoneWrapper(options);

            return dropzone;
        }
    }

})();
